export default {"src":"/_next/static/media/increse-productivity.c440b7c5.svg","height":151,"width":151,"blurWidth":0,"blurHeight":0};